// extracted by mini-css-extract-plugin
export default {"backgroundLogin":"LoginPage_backgroundLogin__0EvFe","cardButton":"LoginPage_cardButton__K1BPq"};